import { createContext, useContext, useCallback, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=authed
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    // Session lives in a secure httpOnly cookie — ask the server who we are.
    api
      .me()
      .then((u) => setUser(u))
      .catch(() => setUser(false))
      .finally(() => setChecked(true));
  }, []);

  const login = useCallback(async (email, password) => {
    const { user: u } = await api.login(email, password); // sets httpOnly cookie
    setUser(u);
    return u;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.logout();
    } catch (err) {
      console.error("Logout request failed", err?.message || err);
    }
    setUser(false);
  }, []);

  const updateSession = useCallback((_token, u) => {
    // Credentials update rotates the httpOnly cookie server-side; just refresh the user.
    if (u) setUser(u);
  }, []);

  const value = useMemo(
    () => ({ user, checked, login, logout, updateSession }),
    [user, checked, login, logout, updateSession]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
